import React from "react";
import BankAccountDetails from "./BankAccountDetails";
import {Formik} from "formik";
import GenericDialog from "../../dialog/GenericDialog";
import {Divider, Grid, Typography} from "@material-ui/core";
import {Button} from "../../formInputs";
import * as Yup from "yup";
import {useActions} from "../../../actions";
import * as PaymentActions from "../../../actions/payment";
import {usePolicyContext} from "./PolicyContext";
import {useSelector} from "react-redux";
import {RootState} from "../../../reducers";
import {joinAsFullName} from "../../../utils/commonUtils";

const initialValues = {
    bankName: "",
    bankAccountHolder: "",
    routingNumber: "",
    accountNumber: "",
    confirmAccountNumber: "",
    checkFrontPath: "",
};

const BankAccountSchema = Yup.object().shape({
    bankName: Yup.string().required("Required"),
    bankAccountHolder: Yup.string().required("Required"),
    routingNumber: Yup.string().required("Required"),
    accountNumber: Yup.string().required("Required"),
    confirmAccountNumber: Yup.string()
        .oneOf([Yup.ref('accountNumber')], 'Account number must match').required("Required"),

});
const BankAccountForm = (props: any) => {
    const {policy, refetchPolicy}: any = usePolicyContext();
    const { user } = useSelector((state: RootState) => state.auth);
    const profile = useSelector((state: RootState) => state.profile);
    const {handleClose, callingFrom} = props;
    const payment = useActions(PaymentActions);
    const saveBankAccountDetails = async (values: any, actions: any) => {
        // let paymentMethodId = values.paymentMethodId;
        const exstingPaymentMethodIds = Array.isArray(policy.paymentMethods) && policy.paymentMethods.map((method) => method.recordKey)
        const paymentMethodPayload = {
            policyNumber: policy.policyNumber,
            emailAddress: user.email,
            accountHolder: values.bankAccountHolder,
            payerName: joinAsFullName(user),
            bankName: values.bankName,
            accountType: 'PersonalChecking',
            routingNumber: values.routingNumber,
            accountNumber: values.accountNumber,
            actionItem: "CHANGE-PAYMENT-METHOD" == callingFrom,
            exstingPaymentMethodIds,

            // files: [values.checkFrontPath, values.checkBackPath] // NIWD-120
            files: [values.checkFrontPath]
        };
        
        await payment.addPaymentMethod(paymentMethodPayload);
        actions.setSubmitting(false);
        await refetchPolicy();
        actions.resetForm();
        handleClose();
    };

    return (
        <Formik initialValues={initialValues} onSubmit={saveBankAccountDetails} validationSchema={BankAccountSchema}>
            {({
                  handleSubmit,
                  isSubmitting
              }) =>
                (
                    <form onSubmit={handleSubmit}>
                        <Typography>
                            You can add additional bank accounts to choose from when making ePay contribution payments.
                            Please
                            enter
                            your bank information below.
                        </Typography>
                        <BankAccountDetails />
                        <Divider/>
                        <Grid item xs={12}>
                            <Button
                                label="Save Account"
                                className="floatRight mb20"
                                type="submit"
                                size="small"
                                variant="contained"
                                color="primary"
                                disabled={isSubmitting}
                                loading={isSubmitting}
                            />
                            <Button
                                label="Cancel"
                                className="floatRight mb20"
                                onClick={handleClose}
                                color="primary"
                                size="small"
                            />
                        </Grid>
                    </form>)
            }
        </Formik>);
}

function BankAccountNew(props: any) {
    const {isNewAccount, setIsNewAccount, paymentFrequency, callingFrom} = props;
    const handleClose = () => {
        setIsNewAccount(false);
    }
    return (
        <GenericDialog open={isNewAccount} title={"Add New Bank Account"} content={<BankAccountForm callingFrom = { callingFrom } paymentFrequency={paymentFrequency} handleClose={handleClose}/>}
                       onClose={handleClose}/>
    );
}

export default BankAccountNew;